export enum SampleSource {
  /** 免费领样 */
  Free = 1,
  /** 种草领样 */
  Grass = 2,
  /** 可退购样 */
  Refundable = 3,
}

export enum SampleInShowcase {
  /** 商品没挂链 */
  NotInShowcase = 0,
  /** 商品已挂链 */
  InShowcase = 1,
}
